import { Suspense } from 'react';
import AboutUsHeroSection from 'app/molecules/AboutUsHeroSection';
import AboutUsTravellingSection from 'app/molecules/AboutUsTravellingSection';
import AboutUsUbainDifferenceSection from 'app/molecules/AboutUsUbainDifferenceSection';
import AboutUsHomeFeelingSection from 'app/molecules/AboutUsHomeFeelingSection';
import AboutUsUrbianTeamSection from 'app/molecules/AboutUsUrbianTeamSection';
import AboutUsUbianValuesSection from 'app/molecules/AboutUsUbianValuesSection';
import Loading from '../../atoms/Loading';

const AboutUs = () => {
  return (
    <>
      <Suspense
        fallback={
          <div>
            <Loading force={true} />
          </div>
        }
      >
        <AboutUsHeroSection />
        <AboutUsTravellingSection />
        <AboutUsUbainDifferenceSection />
        <AboutUsHomeFeelingSection />
        <AboutUsUbianValuesSection />
        <AboutUsUrbianTeamSection />
      </Suspense>
    </>
  );
};

export default AboutUs;
